import { useContext, useEffect, useState } from "react";
import { Avatar, Badge, Link, IconButton } from "@mui/material";
import { Link as RouterLink, useNavigate } from "react-router-dom";
import { UserContext } from "../root";
import "./header.css";
import jwtDecode from "jwt-decode";
import PostService from "../services/PostService";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import AppService from "../services/AppService";
import ReactFlagsSelect from "react-flags-select";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import ChatIcon from "@mui/icons-material/Chat";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useMessageCount } from "../MessageContext";
import useChatNotificationService from "../hooks/useChatNotificationService";
import { Helmet } from "react-helmet-async";
import axios from "axios";
import { getRoleFromToken } from "../utils/roleUtils";

function Header() {
  const { newMessageCount } = useMessageCount();
  const token = localStorage.getItem("user");
  const roleInfo = getRoleFromToken(token);
  const decoded = roleInfo?.decoded;
  // console.log("decoded", decoded);
  const UserId = decoded?.sub || null; // Use optional chaining to avoid null
  const [user, setUsers] = useState([]);
  const {
    countrySate,
    categories,
    categoriesState,
    categoryId,
    categoryNameGlobel,
    searchContaxt,
  } = useContext(UserContext);
  const [setcountryC, setSetCountryC] = countrySate;
  const [stateCategory, setStateCategory] = categories;
  const [mainCategoryId, setMainCategoryId] = categoryId;
  const [searchText, setSearchTest] = searchContaxt;

  const [category, setCategory] = useState("");
  const [categoryName, setCategoryName] = useState("");
  const [categorySlug, setCategorySlug] = useState("");
  const [mainCategoryName, setMainCategoryName] = categoryNameGlobel;
  const [allcategorystate, setAllCategorystate] = categoriesState;
  const [search, setSearch] = useState("");
  const [dataR, setDataR] = useState([]);
  const [suggestions, setSuggestions] = useState([]);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [hitBtn, setHitBtn] = useState(0);
  const [loading, setLoading] = useState(false);
  const [loadingCountry, setLoadingCountry] = useState(true);

  const { getAllChatsRecentHandler, connect } = useChatNotificationService();
  // console.log("newMessageCount",newMessageCount)
  useEffect(() => {
    connect();
    getAllChatsRecentHandler();
  }, []);

  useEffect(() => {
    setLoading(true);

    if (UserId) {
      const getUser = () => {
        PostService.getUser(UserId)
          .then((response) => {
            setUsers(response.data.data);
            // console.log("User data", response.data.data);
            setLoading(false);
          })
          .catch((e) => {
            console.log(e);
            setLoading(false);
          });
      };

      getUser();
    }
  }, [UserId]);

  // console.log("user", user);
  function sc() {
    localStorage.setItem("country", setcountryC);
  }

  useEffect(() => {
    sc();
  }, [setcountryC]);

  const navigate = useNavigate();

  const getMenu = () => {
    AppService.getMenu()
      .then((response) => {
        setDataR(response.data.data);
        setStateCategory(response.data.data);
      })
      .catch((error) => {
        if (
          error.response &&
          error.response.data &&
          error.response.data.message
        ) {
          toast.error(`${error.response.data.message}`, {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
        // else {
        //     toast.error("Something went wrong!", {
        //         position: toast.POSITION.TOP_RIGHT,
        //     });
        // }
        console.log(error);
      });
  };

  function categoryset(e) {
    debugger;
    const {
      id: categoryId,
      subCategory,
      allCategory,
      subcategotyName,
      slug,
    } = JSON.parse(e.target.value);

    setAllCategorystate(allCategory);
    setCategory(categoryId);
    setStateCategory(subCategory);
    setMainCategoryId(categoryId);
    setMainCategoryName(subcategotyName);
    setCategoryName(subcategotyName);
    setCategorySlug(slug);

    if (categoryId === "" || categoryId === null) {
      sendData("", "", search);
      return;
    }

    sendData(categoryId, slug, search);
    console.log("categoryTest", category);
  }
  function searchset(e) {
    const value = e.target.value;
    setSearch(value);
    setSearchTest(value); // Synchronize context immediately

    if (value.length > 0) {
      const filteredSuggestions = [];
      dataR?.forEach((cat) => {
        if (cat.name.toLowerCase().includes(value.toLowerCase())) {
          filteredSuggestions.push({
            name: cat.name,
            id: cat.id,
            slug: cat.slug,
            isCategory: true,
          });
        }
        cat.subCategory?.forEach((sub) => {
          if (sub.name.toLowerCase().includes(value.toLowerCase())) {
            filteredSuggestions.push({
              name: sub.name,
              id: cat.id,
              slug: cat.slug,
              subId: sub.id,
              isCategory: false,
            });
          }
        });
      });
      setSuggestions(filteredSuggestions);
      setShowSuggestions(true);
    } else {
      setSuggestions([]);
      setShowSuggestions(false);
    }
  }



  function sendData(maincat, slug, searchStr) {
    // Use arguments if provided, otherwise fallback to state
    let targetCategory = maincat !== undefined ? maincat : category;
    let targetSlug = slug !== undefined ? slug : categorySlug;
    const targetSearch = (searchStr !== undefined ? searchStr : search) || "";

    let apiSearchTerm = targetSearch;
    let isSmartCategoryMatch = false;

    // Detect if the search term is just the category name
    if (targetCategory === "" || targetCategory === null) {
      const matchedCat = dataR?.find(
        (cat) => cat.name.toLowerCase() === targetSearch.trim().toLowerCase()
      );
      if (matchedCat) {
        targetCategory = matchedCat.id;
        targetSlug = matchedCat.slug;
        apiSearchTerm = ""; // Clear search since we're going TO the category
        isSmartCategoryMatch = true;
      }
    } else {
      // If we are already in a category selection (dropdown or smart match)
      const targetCatObj = dataR?.find((c) => c.id === targetCategory);
      if (
        targetCatObj &&
        targetCatObj.name.toLowerCase() === targetSearch.trim().toLowerCase()
      ) {
        apiSearchTerm = "";
      }
    }

    console.log("targetSlug", targetSlug);
    setSearchTest(apiSearchTerm);
    localStorage.setItem("searchsub", "true");
    setHitBtn(hitBtn + 1);

    if (isSmartCategoryMatch) {
      setCategory(targetCategory);
      setCategorySlug(targetSlug);
    }

    const stateParams = {
      category: targetCategory,
      search: apiSearchTerm,
      view: targetCategory === "" || targetCategory === null, // Use viewAll for All Categories
      subcategory: "",
      allSubcategory: dataR,
      searchsubs: true,
      hitBtn: hitBtn + 1,
    };

    if (targetCategory === "" || targetCategory === null) {
      navigate(`/product/items`, { state: stateParams });
    } else {
      navigate(`/${targetSlug}`, { state: stateParams });
    }
  }
  const [country, setCountry] = useState([]);

  const getCountryList = () => {
    AppService.getCountryList()
      .then((response) => {
        setCountry(response.data.data.country);
        console.log("response.data.data.country", response.data.data.country);
      })
      .catch((error) => {
        if (
          error.response &&
          error.response.data &&
          error.response.data.message
        ) {
          toast.error(`${error.response.data.message}`, {
            position: toast.POSITION.TOP_RIGHT,
          });
        } else {
          // toast.error("Something went wrong!", {
          //     position: toast.POSITION.TOP_RIGHT,
          // });
        }
        console.log(error);
      });
  };

  // console.log("country", JSON.stringify(country));

  useEffect(() => {
    getMenu();
    getCountryList();
  }, []);

  const [countryCode, setCountryCode] = useState("");
  const [selected, setSelected] = useState(() => {
    // Initialize the state with the value from local storage or "KN" as a default
    const storedCountry = localStorage.getItem("selectedCountryC");
    const defaultCountry = localStorage.getItem("defaultCountry");

    const isDefaultCountryValid =
      defaultCountry && country?.cca2 && country.cca2.includes(defaultCountry);

    const defaultCountryValue = isDefaultCountryValid ? defaultCountry : "KN";
    return storedCountry ? JSON.parse(storedCountry)[1] : defaultCountryValue;
  });

  // const [selected, setSelected] = useState(() => {
  //   // Initialize the state with the value from local storage or "KN" as a default
  //   const storedCountry = localStorage.getItem("selectedCountryC");
  //   const defaultCountry = localStorage.getItem("defaultCountry");
  //   // const countryList = /* fetch the country list */;

  //   // Set "KN" as the default if defaultCountry is empty or null
  //   const defaultCountryValue = defaultCountry ? defaultCountry : "KN";

  //   // Check if the defaultCountryValue exists in the country list
  //   const isDefaultCountryValid = country.some(
  //     (country) => country.cca2 === defaultCountryValue
  //   );

  //   // If not, set "KN" as the default
  //   return isDefaultCountryValid ? JSON.parse(storedCountry)[1] : "KN";
  // });

  // const [countryCode, setCountryCode] = useState("");
  // const [selected, setSelected] = useState(() => {
  //   // Initialize the state with the value from local storage or "KN" as a default
  //   const storedCountry = localStorage.getItem("selectedCountryC");
  //   const defaultCountry = localStorage.getItem("defaultCountry");

  //   // Set "KN" as the default if defaultCountry is empty or null
  //   const defaultCountryValue = defaultCountry ? defaultCountry : "KN";

  //   // Check if defaultCountry matches any country ISO code from the list
  //   const isDefaultCountryValid = country.some(
  //     (countryObj) => countryObj.iso === defaultCountryValue
  //   );

  //   return isDefaultCountryValid
  //     ? storedCountry
  //       ? JSON.parse(storedCountry)[1]
  //       : defaultCountryValue
  //     : "KN";
  // });

  const defaultCountry2 = localStorage.getItem("defaultCountry");
  console.log("defaultCountry2", defaultCountry2);

  const fetchData = async () => {
    try {
      const response = await axios.get("https://ipapi.co/json/");
      const data = response.data;

      console.log("data", data);

      // Set default value for the code field based on the API response
      const defaultCode = data.country_code; // Replace with your logic
      setCountryCode(defaultCode);
      setLoadingCountry(false);
      localStorage.setItem("defaultCountry", defaultCode);
      if (defaultCountry2 == "" || defaultCountry2 == null) {
        setSelected(defaultCode);
      }
    } catch (error) {
      console.error("Error fetching IP API data:", error);
      setLoadingCountry(false);
      // Handle errors as needed
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  // console.log("countryCode", countryCode);

  const handleCountrySelect = (code) => {
    const selectedCountry = country.find((item) => item.cca2 === code);

    if (selectedCountry) {
      //   console.log("Selected Country Name:", selectedCountry.name);
      setSelected(code); // Update the selected country in ReactFlagsSelect
      setSetCountryC([selectedCountry.name, code]); // Update your state with the selected country name
      // Update localStorage
      localStorage.setItem(
        "selectedCountryC",
        JSON.stringify([selectedCountry.name, code])
      );
    } else {
      //   console.log("Country not found for code:", code);
    }
  };

  const countries = country?.map((country) => country.cca2);

  // Assuming you have a boolean value for blacklistCountries
  const blacklistCountries = false;

  // const [invisible, setInvisible] = useState(false);

  // const handleBadgeVisibility = () => {
  //   setInvisible(!invisible);
  // };

  return (
    <>
      <section className="sticky-header">
        <header id="header">
          <div className="topbar" style={{ backgroundColor: "#fff" }}>
            <div className="container-fluid">
              <div className="row custom-css-x">
                <div className="col-lg-4">
                  <div className="top-flex-cd">
                    <div class="top-cx-child">
                      <div class="dropdown">
                        <span
                          class="dropdown-toggle"
                          id="dropdownMenuButton"
                          data-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded="false"
                          style={{ cursor: "pointer" }}
                        >
                          <img src="/img/Vector (1).png" alt="download" />
                          <span style={{ marginLeft: 5 }}>
                            {" "}
                            Download The App <i class="fa fa-angle-down"></i>
                          </span>
                        </span>

                        <div
                          class="dropdown-menu cxt_tys"
                          aria-labelledby="dropdownMenuButton"
                        >
                          <ul class="topdr-img">
                            <li>
                              <a
                                href="https://apps.apple.com/us/app/carib-bargains/id6461727224"
                                class="dropdown-item"
                                target="ios"
                              >
                                <i class="fa fa-apple"></i>
                                Ios
                              </a>
                            </li>

                            <li>
                              <a
                                href="https://play.google.com/store/apps/details?id=com.app.caribbargains"
                                class="dropdown-item"
                                target="android"
                              >
                                <i class="fa fa-android"></i>
                                Android
                              </a>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                    {/* <div className="top-cd-child">
                                            <a href="#"> <span><img src="./images/All Icons/coin.png" alt="" /></span> Discount on
                                                Premium Ads </a>
                                        </div> */}
                  </div>
                </div>
                <div className="col-lg-4">
                  {!decoded ? (
                    <div className="mx-buttons">
                      <Link
                        component={RouterLink}
                        to={"/login"}
                        color="gray"
                        type="button"
                        underline="none"
                        className="btn btn-primary side-use-user"
                        data-toggle="modal"
                        data-target="#exampleModal"
                      >
                        <span className="font-icon">
                          <i className="fa fa-user" aria-hidden="true"></i>
                        </span>
                        Login/Register
                      </Link>
                    </div>
                  ) : (
                    <div className="mx-buttons">
                      <Link
                        component={RouterLink}
                        to={roleInfo?.isAdmin ? "/admin" : "/my-profile"}
                        color="gray"
                        type="button"
                        underline="none"
                        className="btn btn-primary side-use-user"
                        style={{ display: "flex", alignItems: "center" }}
                      >
                        <span style={{ display: "flex", alignItems: "center" }}>
                          <div className="avatar">
                            {loading && (
                              <Skeleton
                                circle
                                height="100%"
                                containerClassName="avatar-skeleton"
                              />
                            )}
                            <Avatar
                              alt={user.name}
                              src={user.imageUrl}
                              style={{ display: loading ? "none" : undefined }}
                            />
                          </div>
                          <span style={{ marginLeft: "8px" }}>
                            {loading ? <Skeleton width={70} /> : user?.name}
                            {!loading && !roleInfo?.isAdmin && (
                              <>
                                <Badge
                                  component={RouterLink}
                                  to={"/my-profile#chat"}
                                  color="error"
                                  variant="dot"
                                  invisible={newMessageCount === 0}
                                >
                                  <ChatIcon sx={{ ml: 3 }} />
                                </Badge>
                              </>
                            )}{" "}
                            {roleInfo?.isAdmin && (
                              <span style={{ fontSize: "12px", marginLeft: "5px", color: "#ffa500" }}>
                                (Admin Panel)
                              </span>
                            )}
                            {/* Assuming ChatIcon is your chat icon component */}
                          </span>
                        </span>
                      </Link>
                    </div>
                  )}
                </div>
                <div className="col-lg-4">
                  <div className="fd-wraping">
                    {!decoded ? (
                      <div className="dx-buton">
                        <Link
                          component={RouterLink}
                          to={`/login`}
                          underline="none"
                          type="button"
                          className="btn btn-primary side-use-btn"
                          style={{ color: "white" }}
                        >
                          Post Free Ads
                        </Link>
                      </div>
                    ) : (
                      <div className="dx-buton">
                        <Link
                          component={RouterLink}
                          to={`categories`}
                          underline="none"
                          type="button"
                          className="btn btn-primary side-use-btn"
                          style={{ color: "white" }}
                        >
                          Post Free Ads
                        </Link>
                      </div>
                    )}
                    <div className="flgx">
                      {/* <a href="#countryModal" className="country-flag popup-with-zoom-anim" data-toggle="modal" data-target="#modal-country">
                                                <img src="./images/All Icons/Flag.png" />
                                            </a> */}

                      {loadingCountry ? (
                        <Skeleton
                          height={35}
                          containerClassName="avatar-skeleton"
                        />
                      ) : (
                        <ReactFlagsSelect
                          selected={selected}
                          onSelect={handleCountrySelect}
                          countries={countries}
                          blacklistCountries={blacklistCountries}
                          searchable={true}
                          searchPlaceholder="Search countries"
                        />
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="header-center">
            <div className="container-fluid ">
              <div className="row">
                <div className="col-lg-2 col-md-12" style={{ display: 'flex', alignItems: 'center' }}>
                  <IconButton
                    onClick={() => navigate(-1)}
                    sx={{ mr: 1, color: '#0083ca' }}
                    aria-label="back"
                  >
                    <ArrowBackIcon />
                  </IconButton>
                  <a href="/">
                    {" "}
                    <img
                      src="/img/logo.png"
                      alt="logo"
                      width="180px"
                      className="img-reponsive"
                    />
                  </a>
                </div>
                <div className="col-lg-10 col-md-12">
                  <div className="header-wrapeer">
                    <div className="fx-wrapings">
                      <div className="serch-fields">
                        <div className="col-lg-12 col-md-5 v-center header-search hidden-xs hidden-sm">
                          <form
                            className="searchform"
                            role="search"
                            style={{ width: "100% !important", position: "relative" }}
                            onSubmit={(e) => {
                              e.preventDefault();
                              sendData(category, categorySlug);
                            }}
                          >
                            <div className="search-panel">
                              <select
                                className="mui-select" // Add a custom class for styling
                                id="category"
                                onChange={(e) => {
                                  categoryset(e);
                                }}
                              >
                                {/* <option className="level3" value={JSON.stringify({ id: "", subCategory: dataR,allCategory:true })}>All Category</option> */}
                                <option
                                  className="level3"
                                  value={JSON.stringify({ id: "" })}
                                >
                                  All Category
                                </option>

                                {dataR?.map((item) => (
                                  <option
                                    className="level3"
                                    value={JSON.stringify({
                                      id: item.id,
                                      slug: item.slug,
                                    })}
                                  >
                                    {item.name}
                                  </option>
                                ))}
                              </select>
                            </div>
                            <input type="hidden" name="type" value="product" />
                            <div style={{ flex: 1, position: "relative" }}>
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Find Cars, Mobiles, Jobs and more..."
                                value={search}
                                onChange={(e) => searchset(e)}
                                onBlur={() => setTimeout(() => setShowSuggestions(false), 200)}
                                onFocus={() => search.length > 0 && setShowSuggestions(true)}
                              />
                              {showSuggestions && suggestions.length > 0 && (
                                <ul className="search-suggestions">
                                  {suggestions.map((suggestion, index) => (
                                    <li
                                      key={index}
                                      onMouseDown={(e) => {
                                        e.preventDefault(); // Prevent input focus loss
                                        setSearch(suggestion.name);
                                        setCategory(suggestion.id);
                                        setCategorySlug(suggestion.slug);
                                        setShowSuggestions(false);
                                        sendData(suggestion.id, suggestion.slug, suggestion.name);
                                      }}
                                    >
                                      {suggestion.name}
                                      {suggestion.isCategory ? "" : " (Subcategory)"}
                                    </li>
                                  ))}
                                </ul>
                              )}
                            </div>
                            <span className="input-group-btn">
                              <button
                                className="button_search"
                                type="submit"
                                catdata={category}
                              >
                                <i className="ion-ios-search-strong"></i>
                              </button>
                            </span>
                          </form>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </header>
      </section>
      <div
        className="modal fade"
        id="modal-country"
        tabindex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog country-dialog">
          <div className="modal-content country-content">
            <div className="modal-header country-header">
              <h5 className="modal-title country-title " id="exampleModalLabel">
                {" "}
                <i className="fa fa-map-marker" aria-hidden="true"></i> Select
                your country
              </h5>
              <button
                type="button"
                className="close country-close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="country-in">
                <ul>
                  <li>
                    <div className="count-bo-fg">
                      {/* <select 
                                            className='form-control' 
                                            style={{ height: "63px" }}
                                            onChange={(e) => {
                                                var value = e.target.value.split(",")
                                                setSetCountryC(value)
                                            }}
                                            >                                                  
                                             <option value="">{setcountryC}</option>
                                                {
                                                    country.map((item) =>
                                                <option key={item.cca2} value={[item.name, item.cca2]} selected={item.name === setcountryC} >{item.name}</option>                                                    )
                                                }
                                            </select> */}
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Header;
